import { Injectable } from '@angular/core';
import { PilotPayHttpClient } from 'app/core';
import { Observable } from 'rxjs';
import { NewEmployee } from './add-employee.types';

/**
 * JobTitlesService
 */
@Injectable()
export class AddEmployeeService {
	constructor(http: PilotPayHttpClient) {
		this.http = http;
	}

	private http: PilotPayHttpClient;

	public addEmployee(employee: NewEmployee): Observable<any> {
		return this.http.postRequest('/api/identity/user', employee);
	}
}
